// Store
import { useTemplateStore } from "@/zustand/templateStore";

const Footer = () => {
  const { footer, settings } = useTemplateStore();

  if (!footer) return null;

  return (
    <div className="border-cc-gray-4 border-t p-4 md:p-6">
      <div
        className={`max-w-body mx-auto flex flex-col-reverse items-center justify-between gap-4 text-sm md:flex-row ${
          settings.enable_high_contrast ? "text-cc-dark-gray" : "text-cc-gray"
        }`}
      >
        {footer.footer_show_disclaimer && (
          <div className="inline text-center">
            {footer.tr_footer_disclaimer_text}
          </div>
        )}
        <div className="flex flex-wrap justify-center gap-2 md:inline">
          {footer.footer_links &&
            footer.footer_links?.map((link, index) => {
              const href = !link.footer_link_type
                ? link.footer_custom_link?.footer_custom_link_href
                : link.footer_post_link?.footer_post_link_href;

              const label = !link.footer_link_type
                ? link.footer_custom_link?.tr_footer_custom_link_label
                : link.footer_post_link?.tr_footer_post_link_label;

              return (
                <a
                  key={index}
                  href={href}
                  className="mr-1 whitespace-nowrap md:mr-4"
                >
                  {label}
                </a>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default Footer;
